/**
 * Base directive class shared by the concrete ScrollReveal directives.
 */
export var AbstractNgsRevealDirective = (function () {
    function AbstractNgsRevealDirective(ngsRevealService) {
        this.ngsRevealService = ngsRevealService;
    }
    AbstractNgsRevealDirective.prototype._initConfig = function (value) {
        if (value && typeof value === 'string') {
            this.config = JSON.stringify(value);
        }
        else if (value && typeof value === 'object') {
            this.config = value;
        }
    };
    return AbstractNgsRevealDirective;
}());
//# sourceMappingURL=ngs-reveal-common.js.map


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/~/ng-scrollreveal/ngs-reveal-common.js
// module id = ../../../../ng-scrollreveal/ngs-reveal-common.js
// module chunks = 4